export default "__VITE_ASSET__f8ae4e62__"